/**
 * PlayerState is an object that contains the current state of the media player.
 *
 * @type {class}
 */
export default class PlayerState {
    constructor(
        isReady = -1,
        hasStarted = false,
        isSrcChanging = false,
        isPlaying = false,
        isSeekable = false,
        isPlayingAds = false,
        contentType = null,
        playerState = 'idle'
    ) {
        this.isReady = isReady;
        this.hasStarted = hasStarted;
        this.isSrcChanging = isSrcChanging;
        this.isPlaying = isPlaying;
        this.isSeekable = isSeekable;
        this.isPlayingAds = isPlayingAds;
        this.contentType = contentType;
        this.playerState = playerState;
    }
    clone() {
        return new PlayerState(
            this.isReady,
            this.hasStarted,
            this.isSrcChanging,
            this.isPlaying,
            this.isSeekable,
            this.isPlayingAds,
            this.contentType,
            this.playerState
        );
    }
}
